var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wordExerciseDetails"},[_c('WordList',{attrs:{"list":_vm.list,"total":_vm.total}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }